import type { DetailedSummaryExpensesItemProps } from '@pages/OtherExpenses/context/types'

export const setInitialValues = (data: DetailedSummaryExpensesItemProps) => {
  return {
    accountCode: data.accountingCode || '',
    accountDescription: data.accountingCode || '',
    accountDescriptionText: data.accountingDescription || '',
    otherExpensesAmount: data.otherExpensesAmount?.toFixed(2) || '',
    observations: data.observations || ''
  }
}
